import DropDown from "./components/Dropdown.vue";
import EditButton from "./pages/components/EditButton.vue";
import StateButton from "./pages/components/StateButton.vue";
import StatusButton from "./pages/components/StatusButton.vue";

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue) {
    Vue.component("drop-down", DropDown);
    Vue.component("edit-button", EditButton);
    Vue.component("state-button", StateButton);
    Vue.component("status-button", StatusButton);
  }
};

export default GlobalComponents;
